export default "__VITE_ASSET__UgIpngqV__"